import React from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import Container from '../../../components/Container'
import Image from '../../../components/Image'
import Title from '../../../components/Title'
import WysiwygOutput, { StyledArticle } from '../../../components/WysiwygOutput'
import Button, { StyledButton } from '../../../components/Button'
import NextLink from '../../../components/Next/NextLink'

const Production = () => {
  return (
    <StyledProduction>
      <Container>
        <StyledProductionRow>
          <StyledProductionCell>
            <StyledCellLeftImage>
              <Image
                responsive
                width="620"
                height="1106"
                src={require('../../../assets/images/production-1-min.jpg')}
                alt="production_1"
              />
            </StyledCellLeftImage>

            <StyledCellLeftTopVideo>
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/1M9WeW-KkbE"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </StyledCellLeftTopVideo>
          </StyledProductionCell>

          <StyledProductionCell className="second text">
            <StyledCellTopImage>
              <Image
                responsive
                width="620"
                height="197"
                src={require('../../../assets/images/production-2-min.png')}
                alt="production_2"
                placeholder={false}
              />
            </StyledCellTopImage>

            <StyledProductionTitle>
              <Title>Производство</Title>
            </StyledProductionTitle>

            <StyledProductionDescription>
              <WysiwygOutput>

                <p>
                  Мы готовим настоящую японскую лапшу у себя на производстве по всем правилам и технологиям лучших мировых производителей.  Процесс приготовления лапши очень технологичен, но, несмотря на это, предполагает 100% участие человека с опытом и пониманием происходящего.
                </p>
                <p>
                  Очень важно подобрать оборудование, на котором будет проходить процесс приготовления. Нашим партнерам является компания Yamato.
                </p>
                <p>
                  Процесс приготовления занимает до 3х дней. Одним из важных моментов является ферментация - «созревание лапши». После приготовления и нарезки лапша должна находится при определенной влажности и температуре.
                </p>
                <p>
                  В отличие от остальных известных мировых макаронных изделий, рамен и удон готовится слоями, что в конечном результате делает эту лапшу «пружинистой». Нарезается лапша специальными ножами-резаками, благодаря чему имеет невидимую для глаза шероховатость с 2-х сторон, на которых задерживается бульон и обволакивает её.
                </p>
              </WysiwygOutput>
            </StyledProductionDescription>

            <StyledCellTopVideo>
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/1M9WeW-KkbE"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </StyledCellTopVideo>
          </StyledProductionCell>
        </StyledProductionRow>

        <StyledProductionRow>
          <StyledProductionCell className="text2">
            <StyledProductionTitle>
              <Title>Лапша</Title>
            </StyledProductionTitle>

            <StyledProductionDescription>
              <WysiwygOutput>
                <p>
                  Мы готовим 2 типа лапши: Рамен и Удон.
                </p>
                <p>
                  Удон у нас только в классическом исполнении.
                </p>
                <p>Рамен в разных вариантах: с разными добавками, из разной муки, разной формы и размеров, при этом изготовление четко придерживается основных правил.</p>
                <p>И нарезается через специальные ножи. Благодаря этому лапша имеет невидимую для глаза шероховатость с 2-х сторон, на которой задерживается бульон и обволакивает её.</p>
                <p>Правильную лапшу всегда варят отдельно от бульона, в кипящей воде, что соответствует основному принципу японской кухни: не создать вкус, а раскрыть и подчеркнуть его. Тем самым, складывая в тарелке лапшу, бульон и другие ингредиенты, мы позволяем каждому из них сохранить свой вкус, дополнить и подчеркнуть друг друга.</p>
              </WysiwygOutput>
            </StyledProductionDescription>

            <StyledProductionButton>
              <NextLink href="/box">
                <Button>Купить лапшу</Button>
              </NextLink>
            </StyledProductionButton>
          </StyledProductionCell>

          <StyledProductionCell>
            <StyledProductionImage>
              <Image
                responsive
                width="620"
                height="813"
                src={require('../../../assets/images/mak.jpg')}
                alt="production_3"
              />
            </StyledProductionImage>
          </StyledProductionCell>
        </StyledProductionRow>
      </Container>
    </StyledProduction>
  )
}

Production.defaultProps = {}

Production.propTypes = {}

export default Production

const StyledCellLeftTopVideo = styled.div`
  display: none;

  position: relative;
  padding: 0;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    padding-top: 56.25%;
  }

  iframe,
  video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  ${up('md')} {
    display: block;
    margin-left: -40px;
    margin-top: 30px;
  }
`
const StyledCellTopVideo = styled.div`
  margin-top: 40px;

  position: relative;
  width: 100%;
  padding: 0;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    padding-top: 56.25%;
  }

  ${up('md')} {
    display: none;
  }

  iframe,
  video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`
const StyledProductionImage = styled.div`
  max-width: 620px;
  margin-left: -20px;
  margin-right: -20px;
  margin-top: 80px;
  height: 300px;

  ${up('md')} {
    display: block;
    margin-top: 0;
    margin-left: 0px;
    margin-right: -40px;
    height: auto;
  }

  ${up('xl')} {
    padding-left: 30px;
  }
`
const StyledProductionButton = styled.div`
  margin-top: 74px;

  ${up('md')} {
    margin-top: 34px;
  }

  ${up('xl')} {
    margin-top: 90px;
  }
`
const StyledProductionDescription = styled.div``
const StyledProductionTitle = styled.div`
  margin-bottom: 25px;

  ${up('md')} {
    margin-bottom: 30px;
  }

  ${up('xl')} {
    margin-bottom: 40px;
  }
`
const StyledCellTopImage = styled.div`
  display: none;
  margin-bottom: 20px;

  ${up('md')} {
    display: block;
  }
  ${up('xl')} {
    margin-bottom: 60px;
    padding-right: 60px;
  }
`
const StyledCellLeftImage = styled.div`
  margin-bottom: 22px;
  margin-left: -20px;
  margin-right: -20px;

  ${up('md')} {
    margin-bottom: 0;
    margin-left: -40px;
    margin-right: 0;
  }

  ${up('xl')} {
    height: 803px;
    overflow: hidden;
  }
`
const StyledProduction = styled.section`
  padding-bottom: 0;
  overflow: hidden;

  ${StyledArticle} {
    max-width: 395px;
  }

  .second {
    ${up('md')} {
      padding-top: 90px;
    }
    ${up('xl')} {
      padding-top: 180px;
    }
  }

  ${StyledButton} {
    width: 100%;

    ${up('md')} {
      max-width: 330px;
    }
  }

  ${up('lg')} {
    padding-bottom: 0;
  }
  ${up('xl')} {
    padding-bottom: 0;
  }
`
const StyledProductionRow = styled.div`
  ${up('md')} {
    display: flex;
    flex-wrap: nowrap;
  }

  &:not(:last-child) {
    margin-bottom: 33px;

    ${up('md')} {
      margin-bottom: 0;
    }

    ${up('lg')} {
      margin-bottom: 55px;
    }

    ${up('xl')} {
      margin-bottom: 0;
    }
  }
`
const StyledProductionCell = styled.div`
  ${up('md')} {
    width: 50%;
  }
  ${up('xl')} {
  }

  &.text {
    ${up('md')} {
      padding-left: 60px;
      padding-bottom: 60px;
    }
    ${up('lg')} {
      padding-left: 90px;
      padding-right: 50px;
    }
    ${up('xl')} {
      padding-left: 130px;
      padding-right: 40px;
    }
  }

  &.text2 {
    ${up('md')} {
      padding-right: 60px;
      padding-bottom: 60px;
    }
    ${up('lg')} {
      padding-right: 90px;
      padding-left: 50px;
    }
    ${up('xl')} {
      padding-top: 80px;
      padding-right: 130px;
      padding-left: 40px;
    }
  }
`
